import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userContextSlice from '@/common/slices/userContextSlice';
import { useGuidedExperience } from '../areas/guided-experience/GuidedExperienceProvider';

const MobileGuidedSummaryPage: React.FC = () => {
  const { startExperience } = useGuidedExperience();
  const selectedTeamId = useSelector(userContextSlice.selectors.getSelectedTeamId as any) as number | undefined;
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedTeamId != null) {
      startExperience('welcome-tour');
    }
    navigate('/app/mobile/culture-hub', { replace: true });
  }, [selectedTeamId, startExperience, navigate]);

  return null;
};

export default MobileGuidedSummaryPage;
